// Components/MessagesArea/hooks/useDateHelpers.js
export const useDateHelpers = () => {
    // Función para comparar fechas
    const isSameDay = (date1, date2) => {
        return date1.getDate() === date2.getDate() &&
            date1.getMonth() === date2.getMonth() &&
            date1.getFullYear() === date2.getFullYear();
    };

    // Formatear fecha para mostrar
    const formatDate = (date) => {
        return date.toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        });
    };

    return { isSameDay, formatDate };
};